import _ from "lodash";
import { DatePicker, Select, Table, TableColumnsType } from "antd";
import moment from "moment";
import QueryString from "qs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { getClasses } from "../../api/campusClasses.api";
import { getNotificationList, getNotifications } from "../../api/notification.api";
import { getSemesters } from "../../api/semesters.api";
import Button from "../../components/Button";
import ShowNoticeModal from "../../components/class/class/modals/ShowNoticeModal";
import ErrorResponse from "../../components/ErrorResponse";
import SimpleHeader from "../../components/layout/SimpleHeader";
import Loader from "../../components/Loader";
import Pagination from "../../components/Pagination";
import SelectCampus from "../../components/SelectCampus";
import useAxios from "../../hooks/useAxios";
import config from "../../lib/config";
import { IGetClasses } from "../../models/campusClasses.model";
import { IGetNotificationList, INotificationListItem } from "../../models/notification.model";
import { IGetSemesters, ISemester } from "../../models/semesters.model";
import { RootState } from "../../store/rootReducer";
import SelectEduStep from "../../components/SelectEduStep";
import { getCommonCodeLabel } from "../../lib/store";

const ClassNotice = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetNotificationList>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetSemesters>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetClasses>();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // NT0001 = 알림장 타입
  const NT0001 = commonCodes.find(item => item.commonCode === 'NT0001')?.detailCode;
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find((item) => item.commonCode === 'PR0002',)?.detailCode;
  // SY0005 = 연도
  const SY0005 = commonCodes.find((item) => item.commonCode === 'SY0005',)?.detailCode;
  const _SY0005 = _.orderBy(SY0005, ['orderSeq'], ['desc']);

  const [semesterCode, setSemesterCode] = useState<number>();
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [classCode, setClassCode] = useState<string>();
  const [srtDate, setSrtDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();
  const [page, setPage] = useState(1);
  const [param, setParam] = useState({});
  const [showNoticeVisible, setShowNoticeVisible] = useState(false);
  const [notificationCode, setNotificationCode] = useState<number>();
  const [className, setClassName] = useState<string>();
  const [noticeType, setNoticeType] = useState<string>();
  const [year, setYear] = useState('');
  const [semesterType, setSemesterType] = useState("");
  const [semesterList, setSemesterList] = useState<ISemester[]>();
  
  useEffect(() => {
    const _param: any = {
      pageNo: page,
      perPage: config.pageSize,
    };

    if (currentCampus !== '') {
      _param.campusCode = currentCampus;
    }
    if (query.eduStepCode) {
      _param.eduStepCode = String(query.eduStepCode);
      setEduStepCode(_param.eduStepCode);
    }
    if (query.classCode) {
      _param.classCode = String(query.classCode);
      setClassCode(_param.classCode);
    }
    if (query.srtDate && query.endDate) {
      _param.srtDate = String(query.srtDate);
      _param.endDate = String(query.endDate);
      setSrtDate(_param.srtDate);
      setEndDate(_param.endDate);
    }
    if (query.page) {
      _param.pageNo = Number(query.page);
      setPage(_param.pageNo);
    }
    if (query.noticeType) {
      _param.noticeType = String(query.noticeType);
      setNoticeType(_param.noticeType);
    }
    if (query.year) {
      _param.year = String(query.year);
      setYear(_param.year);
    }
    if (query.semesterType) {
      _param.semesterType = String(query.semesterType);
      setSemesterType(_param.semesterType);
    }
    if (query.semesterCode) {
      _param.semesterCode = String(query.semesterCode);
      //setSemesterCode(_param.semesterCode);
    }

    execute(getNotificationList(_param));
    _param.page = _param.pageNo;
    delete _param.pageNo;
    delete _param.perPage;
    setParam(_param);

  }, [location]);

  useEffect(() => {
    execute2(getSemesters());
  }, []);

  useEffect(() => {
    if (currentCampus && semesterCode) {
      setClassCode(undefined);
      execute3(getClasses(currentCampus, semesterCode));
    }
  }, [currentCampus, semesterCode]);

  const onSearch = () => {
    const _param: any = { page: 1 };

    if (eduStepCode) {
      _param.eduStepCode = eduStepCode;
    }
    if (classCode) {
      _param.classCode = classCode;
    }
    if (srtDate && endDate) {
      _param.srtDate = srtDate;
      _param.endDate = endDate;
    }
    if (noticeType) {
      _param.noticeType = noticeType;
    }
    if(year) {
      _param.year = year;
    }
    if(semesterType) {
      _param.semesterType = semesterType;
    }
    if(semesterCode) {
      _param.semesterCode = semesterCode;
    }

    history.push(`/class/notice?${QueryString.stringify(_param)}`);
  }

  useEffect(() => {
    fnSetSemesterList(year, semesterType);
  }, [res2]);

  const fnSetSemesterList = (tYear : string, tSemesterType : string) => {
    setSemesterCode(undefined);
    if(res2?.data) {
      let tempList = _.cloneDeep(res2.data);
      
      if(tYear) {
        tempList = tempList.filter((item)=>{
          return item.learningYearCode === tYear;
        });
      }

      if(tSemesterType) {
        tempList = tempList.filter((item)=>{
          return (tSemesterType ? item.semesterType === tSemesterType : true);
        });
      }
      
      setSemesterList(tempList);
    }
  }

  const columns: TableColumnsType<INotificationListItem> = [
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: (value) => getCommonCodeLabel('PR0006', value, i18n.language),
    },
    {
      title: t('program.semester.column11'),
      dataIndex: 'semesterType',
      align: 'center',
      render: (value) => getCommonCodeLabel('PR0002', value, i18n.language),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
      sorter: (a, b) => a.className?.localeCompare(b.className),
    },
    {
      title: t('class.notice.noticeType'),
      dataIndex: 'noticeType',
      key: 'noticeType',
      align: 'center',
      render: (value) => getCommonCodeLabel('NT0001', value, i18n.language),
      sorter: (a, b) => a.className?.localeCompare(b.className),
    },
    {
      title: t('class.notice.column1'),
      dataIndex: 'classTimeSeq',
      key: 'classTimeSeq',
      align: 'center',
      render: (value) => (value)?value:'-',
      sorter: (a, b) => a.classTimeSeq - b.classTimeSeq,
    },
    {
      title: t('class.notice.column2'),
      dataIndex: 'subjectName',
      key: 'subjectName',
      align: 'center',
      sorter: (a, b) => a.subjectName?.localeCompare(b.subjectName),
    },
    {
      title: t('class.notice.column3'),
      dataIndex: 'title',
      key: 'title',
      align: 'center',
      
      sorter: (a, b) => a.title?.localeCompare(b.title),
      render: (value) => {
        if (value && value.length > 40) {
          return <div className="text-left ml-2">{value.substring(0, 40) + '...'}</div>;
        }
        return <div className="text-left ml-2">{value}</div>;
      },
    },
    {
      title: t('class.notice.column4'),
      dataIndex: 'alarmYN',
      key: 'alarmYN',
      align: 'center',
      sorter: (a, b) => a.alarmYN?.localeCompare(b.alarmYN),
    },
    {
      title: t('class.notice.column5'),
      dataIndex: 'resvYn',
      key: 'resvYn',
      align: 'center',
      sorter: (a, b) => a.resvYn?.localeCompare(b.resvYn),
      render: (value) => value==='Y'?t('message.smsSend.column4'):'-',
    },
    {
      title: t('campus.staff.column4'),
      dataIndex: 'registDate',
      key: 'registDate',
      align: 'center',
      sorter: (a, b) => a.alarmYN?.localeCompare(b.alarmYN),
    },
  ];

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
          <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>{t('common.placeholder.1')}</label>
            <div>
              <SelectEduStep
                eduStepCode={eduStepCode}
                setEduStepCode={setEduStepCode}
                width={150}
                includeAll
                fullWidth
              />
            </div>
          </li>
          <li>
            <label>
              {t('program.semester.column9')}
            </label>
            <Select
              className="w-120p"
              value={year}
              onChange={value => {
                setYear(value);
                fnSetSemesterList(value, semesterType);
              }}
            >
              <Select.Option value="">
                {t('common.text.all')}
              </Select.Option>
              {
                _SY0005!.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>
          <li>
          <label>{t('common.semester.type')}</label>
            <Select
              value={semesterType}
              onChange={(value)=>{
                if(setSemesterType) {
                  setSemesterType(value);
                }
                fnSetSemesterList(year, value);
              }}
            >
              <Select.Option value="">
                {t('common.text.all')}
              </Select.Option>
              {
                PR0002?.map((item) => {
                  return (
                    <Select.Option
                        key={item.detailCode}
                        value={item.detailCode}
                    >
                        {i18n.language === 'ko' ? item.korName : item.engName}
                    </Select.Option>
                  );
                })
              }
            </Select>
          </li>
          <li>
            <label>{t('class.class.placeholder4')}</label>
            <div>
              <Select
                placeholder={t('class.class.placeholder4')}
                value={semesterCode}
                onChange={value => setSemesterCode(value)}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {
                  semesterList?.map((item: ISemester) => {
                    return (
                      <Select.Option
                        key={item.semesterCode}
                        value={item.semesterCode}
                      >
                        {item.semesterName}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </div>
          </li>
          <li>
            <label>{t('common.menu.class')}</label>
            <div>
              <Select
                placeholder={t('common.menu.class')}
                value={classCode}
                onChange={value => setClassCode(value)}
              >
                {
                  res3?.data?.map((item: any) => {
                    return (
                      <Select.Option
                        key={item.classCode}
                        value={item.classCode}
                      >
                        {item.className}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </div>
          </li>
          <li>
            <label>{t('class.notice.noticeType')}</label>
            <div>
              <Select
                placeholder={t('class.notice.noticeType')}
                value={noticeType}
                onChange={value => {
                    setNoticeType(value);
                }}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {
                    NT0001?.map((item: any) => {
                        return (
                          <Select.Option
                                key={item.detailCode}
                                value={item.detailCode}
                            >
                                {item.korName}
                          </Select.Option>
                        )
                    })
                }
              </Select>
            </div>
          </li>
          <li>
            <label>{t('sms.list.column1')}</label>
            <div className="date-picker__area">
              <DatePicker
                value={srtDate ? moment(srtDate) : undefined}
                onChange={(e) => {
                  if (e === null) setSrtDate('');
                  else setSrtDate(moment(e).format('YYYYMMDD'));
                }}
              />
              ~
              <DatePicker
                value={endDate ? moment(endDate) : undefined}
                onChange={(e) => {
                  if (e === null) setEndDate('');
                  else setEndDate(moment(e).format('YYYYMMDD'));
                }}
              />
            </div>
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading || isLoading2 || isLoading3 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <SimpleHeader
        parentMenu={t('common.menu.class')}
        currentMenu={t('class.notice.title1')}
        onlyTitle={true}
      />

      <div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  setNotificationCode(record.notificationCode);
                  setClassName(record.className);
                  setShowNoticeVisible(true);
                },
              };
            }}
            rowClassName="pointer"
            rowKey="counselCode"
          />
        </div>
        <div className="comm-bx__between">
          <div className="common-paging center">
            <Pagination
              count={res?.total || 0}
              page={page}
              param={param}
              path="/class/notice"
            />
          </div>
        </div>
      </div>
      {
        showNoticeVisible &&
          <ShowNoticeModal
            visible={showNoticeVisible}
            setVisible={setShowNoticeVisible}
            event={{ id: notificationCode }}
            className={className}
            noButton
            doGetClassNotice={() => {}}
          />
      }
    </div>
    </>
  );
}

export default ClassNotice;
